import { FormModel, templateConstraintFields } from '../index'

export function getFormModelKeys(): (keyof FormModel)[] {
  return [
    'typeItem',
    'name',
    'description',
    'availableCustomerSupport',
    'numberOfPoints',
    'multiUseRewards',
    ...templateConstraintFields,
  ]
}
